import { render, staticRenderFns } from "./TxnDetail.vue?vue&type=template&id=bb18703e&scoped=true"
import script from "./TxnDetail.vue?vue&type=script&lang=js"
export * from "./TxnDetail.vue?vue&type=script&lang=js"
import style0 from "./TxnDetail.vue?vue&type=style&index=0&id=bb18703e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb18703e",
  null
  
)

export default component.exports